

import React from 'react';
import { Link } from 'react-router-dom';

import media1 from '../assets/media/media1.jpeg';
import media2 from '../assets/media/media2.jpeg';
import media3 from '../assets/media/media3.jpeg';
import mandala from '../assets/wallpaper.png';
import ScrollToHashElement from '../pages/ScrollToHashElement'; // 👈 Import here

const Media = () => {
  return (
    <div
      id="media"
      className="!bg-white !pt-12 !pb-[135px] !px-6 sm:!px-6 lg:!px-20 !relative !overflow-hidden"
    >
      <ScrollToHashElement />
      {/* Mandala Backgrounds (Hidden on 440px and smaller) */}
      <img
        src={mandala}
        alt="Mandala Top Right"
        className="!absolute !top-[-300px] !right-[-220px] !w-[500px] !opacity-[0.7] !z-0 max-[440px]:!hidden"
      />
      <img
        src={mandala}
        alt="Mandala Top Left"
        className="!absolute !top-[-300px] !left-[-220px] !w-[500px] !opacity-[0.7] !z-0 max-[440px]:!hidden"
      />
      <img
        src={mandala}
        alt="Mandala Bottom Right"
        className="!absolute !bottom-[-300px] !right-[-220px] !w-[500px] !opacity-[0.7] !z-0 max-[440px]:!hidden"
      />
      <img
        src={mandala}
        alt="Mandala Bottom Left"
        className="!absolute !bottom-[-300px] !left-[-220px] !w-[500px] !opacity-[0.7] !z-0 max-[440px]:!hidden"
      />

      {/* Section Heading */}
      <div className="!text-center !mb-[50px] mt-[80px]">
        <h2 className="!text-[32px] max-[440px]:!text-[20px] !font-bold !text-[#AD2F3B] !mt-[-30px] !uppercase">
          Media Spotlight
        </h2>
        <div className="!w-[300px] !h-[2px] !bg-[#AD2F3B] !mx-auto !mt-2 !rounded-full max-[440px]:!w-[200px]"></div>
      </div>

      {/* Media Cards */}
      <div className="!flex !flex-wrap !justify-center !gap-16">
        {/* Card Template */}
        {[
          { title: "Gallery", image: media3, link: "", btn: "All Gallery" },
          { title: "News Updates", image: media1, link: "", btn: "All News" },
          { title: "Blogs", image: media2, link: "/blog", btn: "All Blogs" },
        ].map((item, index) => (
          <div
            key={index}
            className="!w-full sm:!w-[400px] !h-[500px] max-[440px]:!w-[300px] max-[440px]:!h-[370px] !border-2 !border-[#AD2F3B] !rounded-lg !overflow-hidden !shadow-md !flex !flex-col"
          >
            <h3 className="!text-center !font-semibold !mb-0 !bg-gradient-to-r !from-[#fff] !to-[#f9dada] !p-2 !text-xl max-[440px]:!text-[16px]">
              {item.title}
            </h3>
            <div className="!flex-grow !relative !object-cover ">
              <img
                src={item.image}
                alt={item.title}
                className="!w-full h-full !object-cover !absolute !inset-0 "
              />
            </div>
            <Link
              to={item.link}
              className="!bg-[#AD2F3B] !text-white !text-center !py-2 !block !cursor-pointer !no-underline transition-all !duration-300 hover:!bg-white hover:!text-[#AD2F3B] !border-t-2 !border-[#AD2F3B] !text-[16px] max-[440px]:!text-[14px]"
            >
              {item.btn} &nbsp; ➜
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Media;
